/* Cubold cart: live item count on the header icon, and the icon opens the cart drawer */
(function () {
  var badges = function () { return document.querySelectorAll('[data-cg-badge]'); };
  var last = null;

  function render(count) {
    count = Number(count) || 0;
    var increased = last !== null && count > last;
    last = count;

    badges().forEach(function (badge) {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.setAttribute('data-count', String(count));
      badge.hidden = count < 1;
      if (increased) {
        badge.classList.remove('cg-bump');
        void badge.offsetWidth;
        badge.classList.add('cg-bump');
      }
    });

    if (increased) {
      document.querySelectorAll('[data-cg-cart]').forEach(function (icon) {
        icon.classList.remove('cg-wiggle');
        void icon.offsetWidth;
        icon.classList.add('cg-wiggle');
      });
    }
  }

  function refresh() {
    return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { render(cart.item_count); })
      .catch(function () {});
  }

  var current = badges()[0];
  if (current) last = Number(current.getAttribute('data-count')) || 0;

  /* Any cart request from the theme, the drawer or the cart page updates the count when it finishes */
  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var request = nativeFetch.apply(this, arguments);
      if (CART_URL.test(url)) {
        request.then(function () { setTimeout(refresh, 150); }).catch(function () {});
      }
      return request;
    };
  }

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event && event.cartData;
      if (data && typeof data.item_count === 'number') render(data.item_count);
      setTimeout(refresh, 300);
    });
  }

  document.addEventListener('cg:cart-added', function () { setTimeout(refresh, 200); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  setInterval(function () { if (!document.hidden) refresh(); }, 5000);
  refresh();

  /* The cart icon opens the drawer everywhere except the cart page */
  document.addEventListener('click', function (event) {
    var icon = event.target.closest && event.target.closest('[data-cg-cart]');
    if (!icon || window.location.pathname === '/cart') return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(icon);
  });
})();